import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
var _hoisted_1 = { class: "container_esh" };
var _hoisted_2 = { class: "flex flex-row justify-center gap-2" };
var _hoisted_3 = { class: "inline-text max-w-[150px]" };
var _hoisted_4 = { class: "inline-text" };
var _hoisted_5 = { class: "inline-text" };
var _hoisted_6 = { class: "inline-text" };
var _hoisted_7 = { class: "flex flex-col justify-center items-center text-center gap-2" };
var _hoisted_8 = {
    class: "text-sm text-center",
    style: { "color": "#1a576a" }
};
var _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", null, "Equazione utilizzata:", -1);
var _hoisted_10 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
var _hoisted_11 = { key: 0 };
var _hoisted_12 = { key: 1 };
var _hoisted_13 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import BaseOutput from "../components/BaseOutput.vue";
import BaseInput from "../components/BaseInput.vue";
import BaseButtons from "../components/BaseButtons.vue";
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'gaultCalculator',
    props: {
        altezza: {},
        eta: {},
        peso: {},
        creatininemia: {},
        sesso: {}
    },
    setup: function (__props) {
        var props = __props;
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var creatinemiaValid = ref("");
        var creatininemia = ref();
        var result = ref("...");
        function checkInputValidity() {
            if (creatininemia.value < 0.1 || creatininemia.value > 13) {
                creatinemiaValid.value =
                    "Controlla il valore inserito. I valori sono compresi tra 0.1 e 13";
            }
            else {
                creatinemiaValid.value = "";
            }
        }
        // Assegna il valore del sesso
        var sesso = (props.sesso == 'male') ? 'Maschile' : 'Femminile';
        function resetForm() {
            creatinemiaValid.value = "";
            creatininemia.value = "";
            result.value = "...";
        }
        function calculator() {
            creatininemia.value = (isNaN(creatininemia.value) || creatininemia.value < 0.1) ? 1 : creatininemia.value;
            checkInputValidity();
            result.value = Math.round((((140 - props.eta) * props.peso) / (72 * creatininemia.value)));
            if (props.sesso == "Femminile") {
                result.value = Math.round(result.value * 0.85);
            }
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(BaseInput, {
                                style: { "width": "150px" },
                                label: "Età",
                                type: "number",
                                step: "0.1",
                                lang: "it",
                                value: _ctx.eta,
                                disabled: ""
                            }, null, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(BaseInput, {
                                style: { "width": "150px" },
                                label: "Sesso",
                                type: "string",
                                step: "0.1",
                                lang: "it",
                                value: _unref(sesso),
                                disabled: ""
                            }, null, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(BaseInput, {
                                style: { "width": "150px" },
                                label: "Peso (in kg)",
                                type: "number",
                                step: "0.1",
                                lang: "it",
                                value: _ctx.peso,
                                disabled: ""
                            }, null, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(BaseInput, {
                                style: { "width": "150px" },
                                label: "Creat. sierica mg/dL",
                                placeholder: "1",
                                type: "number",
                                step: "0.1",
                                lang: "it",
                                modelValue: _unref(creatininemia),
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(creatininemia) ? (creatininemia).value = $event : creatininemia = $event); }),
                                onValidateInput: checkInputValidity,
                                isInputValid: _unref(creatinemiaValid)
                            }, null, 8, ["modelValue", "isInputValid"])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createVNode(BaseButtons, {
                        hiddenSalvaButton: "",
                        onClearForm: resetForm,
                        onCalculate: calculator
                    }),
                    _createVNode(BaseOutput, {
                        class: "flex text-sm basecolor-mr",
                        label: _ctx.$t('creatOutput'),
                        key: "number",
                        result: _unref(result),
                        unit: "ml/min"
                    }, null, 8, ["label", "result"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    (_unref(sesso) == 'Femminile')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Clearance della creatinina = 0.0205 * (140 - età) * peso * 0.85 / creat. sierica. "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, " Clearance della creatinina = 0.0205 * (140 - età) * peso / creat. sierica. ")),
                    _hoisted_13
                ])
            ], 64));
        };
    }
});
